import { Button } from "@bigbinary/neeto-atoms";
import { Plus } from "lucide-react";
import PropTypes from "prop-types";

const AddNew = ({ label = "", onClick, ...otherProps }) => (
  <div className="mb-2 px-2 py-1.5" {...otherProps}>
    <Button {...{ onClick }} className="gap-1 text-sm" size="sm" variant="link">
      <Plus size={16} />
      {label}
    </Button>
  </div>
);

AddNew.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default AddNew;
